<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <hr />

        <div>
            <div class="form-inline">
                <label class="sr-only"
                       for="newLabel">
                    Label
                </label>
                <input type="text"
                       v-model="addResellerPipelineObj.insuranceLineId"
                       class="form-control form-control-sm mb-2 mr-sm-2"
                       id="newLabel"
                       placeholder="Insurance Line Id">
                <label class="sr-only" for="ruleComp">Name</label>
                <select id="reseller" class="form-control form-control-sm mb-2 mr-sm-4" v-model="addResellerPipelineObj.resellerId">
                    <option :value="0">ANY - Reseller</option>
                    <option v-for="reseller in resellers" :key="'reseller_' + reseller.id" v-bind:value="reseller.id">
                        {{ reseller.label }}
                    </option>
                </select>

                <label class="sr-only"
                       for="newLabel">
                    Label
                </label>
                <input type="text"
                       v-model="addResellerPipelineObj.productId"
                       class="form-control form-control-sm mb-2 mr-sm-2"
                       id="newLabel"
                       placeholder="Product">
                <label class="sr-only"
                       for="newLabel">
                    Label
                </label>
                <input type="text"
                       v-model="addResellerPipelineObj.deviceTypeId"
                       class="form-control form-control-sm mb-2 mr-sm-2"
                       id="newLabel"
                       placeholder="Device Type">
                <label class="sr-only"
                       for="newLabel">
                    Label
                </label>
                <input type="text"
                       v-model="addResellerPipelineObj.deviceMakeId"
                       class="form-control form-control-sm mb-2 mr-sm-2"
                       id="newLabel"
                       placeholder="Device Make">
                <label class="sr-only"
                       for="incidentType">
                    IncidentType
                </label>
                <select id="incidentType" class="form-control form-control-sm mb-2 mr-sm-4" v-model="addResellerPipelineObj.incidentTypeId">
                    <option :value="0">ANY - Incident Type</option>
                    <option v-for="type in incidentTypes" :key="'incidentType_' + type.id" v-bind:value="type.id">
                        {{ type.label }}
                    </option>
                </select>
                <label class="sr-only"
                       for="pipeline">
                    Label
                </label>
                <select id="pipeline" class="form-control form-control-sm mb-2 mr-sm-4" v-model="addResellerPipelineObj.pipelineId">
                    <option :value="null" disabled>Select a Pipeline...</option>
                    <option v-for="pipeline in pipelineList" :key="'pipeline_' + pipeline.id" v-bind:value="pipeline.id">
                        {{ pipeline.label }}
                    </option>
                </select>
                <div class="custom-control custom-checkbox  mb-2 mr-sm-4">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="newEnabled"
                           v-model="addResellerPipelineObj.enabled">
                    <label class="custom-control-label"
                           for="newEnabled">
                        Enabled
                    </label>
                </div>
                <button class="btn btn-sm btn-primary mb-2" @click="handleAddResellerPipelineClick">Add Reseller Pipeline</button>
            </div>
        </div>

        <data-list :dataCols="pipelineCols"
                   :dataListItems="resellerPipelineList"
                   :tableClass="'table table-striped table-sm'"
                   @dbl-click="handleItemDblClick" />



        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
import { searchInputs } from '@/ui.config/inputs/claimsBucket1SearchInputs'
import { resellerPipelineCols } from '@/ui.config/cols/pipelineCols'

import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name:'ResellerPipelines',
    mixins: [
        
    ],
    components: {
        PageHeader,
        DataList,
        Loading
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Reseller Pipelines',
            },
            searchInputs: searchInputs,
            pipelineCols: resellerPipelineCols,

            addResellerPipelineObj: {
                insuranceLineId: 0,
                resellerId: 0,
                productId: null,
                deviceTypeId: null,
                deviceMakeId: null,
                incidentTypeId: 0,
                pipelineId: null,
                enabled: true
            },

            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'ClaimantEmail',
                    label: 'Claimant Email'
                },
                {
                    id: 1,
                    key: 'DateCreated',
                    label: 'Submitted Date'
                },
                {
                    id: 2,
                    key: 'IncidentDate',
                    label: 'incident Date'
                }
            ]
        }
    },
    beforeMount() {
        this.fetchResellerPipelines({})
        this.fetchResellers()
        this.fetchPipelines({})
        this.fetchIncidentTypes()
       
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        searchInputsEx() {
            var { resellers, incidentTypes,  searchInputs } = this

            if (resellers) {
                searchInputs[0].options = resellers
            }

            if (incidentTypes) {
                searchInputs[5].options = incidentTypes
            }

            return searchInputs
        },
        resellers() {
            return this.$store.getters.resellers
        },
        resellerPipelineList() {
            return this.$store.getters.resellerPipelineList
        },
        pipelineList() {
            return this.$store.getters.pipelineList
        },
        incidentTypes() {
            return this.$store.getters.incidentTypesDisplayLabel1
        },
    },
    methods: {
        ...mapActions([
            'fetchPipelines',
            'fetchResellerPipelines',
            'fetchResellers',
            'fetchIncidentTypes',
            'setSelectedResellerPipeline',
            'addResellerPipeline'
        ]),
        handleItemDblClick(payload) {
            this.setSelectedResellerPipeline(payload)
            this.$router.push('/resellerpipelines/rules')
        },
        handleAddResellerPipelineClick() {
            //console.log(this.addResellerPipelineObj)
            this.addResellerPipeline(this.addResellerPipelineObj)
        },
    }
}
</script>

<style>
    
</style>
